import { jsx as _jsx } from "react/jsx-runtime";
import { useAppDispatch } from '../hooks';
import { Dialog } from '../components/Dialog';
import { FormGroup } from '../components/FormGroup';
import { savePanel } from '../actions/SavePanel';
import { createPanel } from '../actions/CreatePanel';
import { deletePanel } from '../actions/DeletePanel';
const DeleteButton = props => (_jsx("button", { type: "button", className: "delete lw danger", onClick: props.onClick, children: "Ta bort" }));
const CancelButton = props => (_jsx("button", { type: "button", className: "lw", onClick: props.onClick, children: "Avbryt" }));
const SaveButton = props => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Spara \u00E4ndringar" }));
const CreateButton = props => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Skapa panel" }));
export const DialogPanelEdit = (props) => {
    const dispatch = useAppDispatch();
    let dialogTitle, footerleft, footerright;
    if (props.panelId != null) {
        const panel_id = props.panelId;
        dialogTitle = 'Redigera panel';
        footerleft = [
            (_jsx(DeleteButton, { onClick: () => dispatch(deletePanel(panel_id, props.onClose)) }, "delete"))
        ];
        const panel = Object.assign({ id: panel_id }, props.panelData);
        footerright = [
            (_jsx(CancelButton, { onClick: props.onClose }, "cancel")),
            (_jsx(SaveButton, { onClick: () => dispatch(savePanel(panel, props.onClose)) }, "save"))
        ];
    }
    else {
        dialogTitle = 'Skapa panel';
        footerright = [
            (_jsx(CancelButton, { onClick: props.onClose }, "cancel")),
            (_jsx(CreateButton, { onClick: () => dispatch(createPanel(props.panelData, props.onClose)) }, "create"))
        ];
    }
    return (_jsx(Dialog, { title: dialogTitle, footerleft: footerleft, footerright: footerright, isOpen: props.isOpen, close: props.onClose, children: _jsx(FormGroup, { label: "Namn", children: _jsx("input", { type: "text", name: "title", value: props.panelData.title, onChange: e => props.setPanelData(Object.assign(Object.assign({}, props.panelData), { title: e.target.value })) }) }) }));
};
